<template>
  <div>
    <div class="mb-2 flex items-baseline justify-between">
      <span class="text-lg font-bold">Truy cập nhanh</span>
      <RouterLink
        class="link text-primary text-sm"
        :to="{
          name: 'ClientExplorerScanHistory',
          query: {
            page: 1,
            size: 20,
          },
        }"
      >
        Xem lịch sử
      </RouterLink>
    </div>
    <ul>
      <Loading v-if="actionHistoryQuery.isPending.value" />
      <template
        v-else
        v-for="action_item in actionHistoryQuery.data.value?.data"
        :key="action_item.action"
      >
        <li
          v-if="action_item.path"
          class="tooltip link mb-2 line-clamp-1 truncate"
          :data-tip="action_item.path"
        >
          <RouterLink
            :to="{
              name: 'ClientExplorer',
              query: {
                ...$route.query,
                path: action_item.path,
              },
            }"
          >
            {{ action_item.path }}
          </RouterLink>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import Loading from "@/components/LoadingTemplate.vue";
import { ref } from "vue";
import type { action_str, type_str } from "..";
import { useActionHistoryQuery } from "./useAction";

const actionHistoryQuery = useActionHistoryQuery(
  ref({
    type: "explore" as type_str,
    action: "scan" as action_str,
    distinct: true,
  }),
);
</script>
